import { render, staticRenderFns } from "./OrganLungs.vue?vue&type=template&id=b91d911e&"
var script = {}
import style0 from "./OrganLungs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports